// extracted by mini-css-extract-plugin
module.exports = {"bottomText":"bottom-text_bottomText__9qJrd"};